import type { WorldState } from "./state";

/**
 * 32-bit FNV-1a hash of the full world state. Used by determinism tests and, later,
 * for desync detection in online play. Not cryptographic.
 */
export function hashWorld(world: WorldState): string {
	const text = JSON.stringify(world);
	let h = 0x811c9dc5;
	for (let i = 0; i < text.length; i++) {
		h ^= text.charCodeAt(i);
		h = Math.imul(h, 0x01000193);
	}
	return (h >>> 0).toString(16).padStart(8, "0");
}
